module.exports = __webpack_public_path__ + "media/dashboard/assets/icons/ic_cancel-6f31211d227317feec71e4f6a2090fb2.svg";